import React from 'react';

export const AUTOFRAMED_CAPTIONS_INFOBOX_MESSAGE_EDIT = (
  <>
    <b>AUTOFRAMED CAPTIONS:</b> Changes will override all scene-level manual
    edits. AutoFrame will still position captions for the best composition in
    your exported videos, but this preview does not reflect that.
  </>
);

export const DYNAMIC_VIDEO_AUTOFRAME_INFOBOX_MESSAGE = (
  <>
    <b>Low-res preview:</b> since AutoFrame is turned on your exported videos
    will automatically track and center people to keep them in frame, but this
    preview does not reflect that.
  </>
);

export const AUTOFRAMED_CAPTIONS_INFOBOX_MESSAGE_CREATE = (
  <>
    <b>AUTOFRAMED CAPTIONS:</b> AutoFrame will automatically position captions
    for the best composition in your exported videos, but this preview does not
    reflect that.
  </>
);
